var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleFill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "people-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.385,
    height: 15.289,
    viewBox: "0 0 20.385 15.289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_577",
    "data-name": "Path 577",
    d: "M7.274,17.289A1.248,1.248,0,0,1,6,16.015c0-1.274,1.274-5.1,6.37-5.1s6.37,3.822,6.37,5.1a1.248,1.248,0,0,1-1.274,1.274Zm5.1-7.645A3.822,3.822,0,1,0,8.548,5.822,3.822,3.822,0,0,0,12.37,9.645Z",
    transform: "translate(1.645 -2)",
    fill: "#586973"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_578",
    "data-name": "Path 578",
    d: "M6.646,15.371A2.851,2.851,0,0,1,6.37,14.1a6.081,6.081,0,0,1,2.467-4.74A8.059,8.059,0,0,0,6.37,9C1.274,9,0,12.822,0,14.1a1.248,1.248,0,0,0,1.274,1.274Z",
    transform: "translate(0 -0.081)",
    fill: "#586973",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_579",
    "data-name": "Path 579",
    d: "M5.185,9.37A3.185,3.185,0,1,0,2,6.185,3.185,3.185,0,0,0,5.185,9.37Z",
    transform: "translate(0.548 -1.726)",
    fill: "#586973"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleFill);
export default __webpack_public_path__ + "static/media/people-fill.c82ccd1a.svg";
export { ForwardRef as ReactComponent };